<template>
  <a-card title="价格规则" :bordered="false">
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <p>提示：结算价格，指深捷旅给分销商的分销价格；零售价，指深捷旅显示的零售价格；</p>
      <!--      <a-form-model-item label="提示">结算价格，指深捷旅给分销商的分销价格；零售价，指深捷旅显示的零售价格；</a-form-model-item>-->
      <a-form-model-item label="采购价格">捷旅结算价</a-form-model-item>
      <a-form-model-item label="同行价" prop="peerRatio">
        <span>采购价 + 采购价 *</span>
        <a-input-number
          style="width: 80px;margin: 0 5px;"
          placeholder="请输入"
          v-model="ruleForm.peerRatio"
          :min="0"
          :max="100"
          :precision="0"
          @change="(e) =>inputNumberChange(e,'peerRatio')"
        >
        </a-input-number>
        <span>%</span>
      </a-form-model-item>
      <a-form-model-item label="销售价" prop="saleRatio">
        <span>同行价 + 同行价 *</span>
        <a-input-number
          style="width: 80px;margin: 0 5px;"
          placeholder="请输入"
          v-model="ruleForm.saleRatio"
          :min="0"
          :max="100"
          :precision="0"
          @change="(e) =>inputNumberChange(e,'saleRatio')"
        >
        </a-input-number>
        <span>%</span>
      </a-form-model-item>
      <a-form-model-item label="市场价格" prop="marketRatio">
        <span>销售价 + 销售价 *</span>
        <a-input-number
          style="width: 80px;margin: 0 5px;"
          placeholder="请输入"
          v-model="ruleForm.marketRatio"
          :min="0"
          :max="100"
          :precision="0"
          @change="(e) =>inputNumberChange(e,'marketRatio')"
        >
        </a-input-number>
        <span>%</span>
      </a-form-model-item>
      <a-form-model-item label="佣金" prop="commissionRatio">
        <span>销售价 *</span>
        <a-input-number
          style="width: 80px;margin: 0 5px;"
          placeholder="请输入"
          v-model="ruleForm.commissionRatio"
          :min="0"
          :max="100"
          :precision="0"
          @change="(e) =>inputNumberChange(e,'commissionRatio')"
        >
        </a-input-number>
        <span>%</span>
      </a-form-model-item>
      <h4>同步设置</h4>
      <!--      <a-form-model-item label="同步设置" :colon="false" />-->
      <a-form-model-item label="自动同步" prop="isSync">
        <a-radio-group v-model="ruleForm.isSync">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
        <span style='color: red;'>*开启后每日0点-5点自动同步一次</span>
      </a-form-model-item>
      <a-form-model-item style="text-align: center" :wrapper-col="{ span: 9, offset: 3 }">
        <a-button
          htmlType="submit"
          type="primary"
          @click="submitEvent"
          :loading="submitLoading"
        >确定
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import SjlHotelMixins from '@/views/service/serviceProvider/sjlHotel/mixins/SjlHotelMixins'

export default {
  name: 'SjlHotelSyncRule',
  mixins: [SjlHotelMixins],
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      ruleForm: {
        peerRatio: '',
        saleRatio: '',
        marketRatio: '',
        commissionRatio: '',
        isSync: 1
      },
      tabRule: {
        peerRatio: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        saleRatio: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        marketRatio: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        commissionRatio: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        isSync: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      this.getHttpServices().getServerApiService().post('shenjie/query', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        if (res) this.ruleForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    inputNumberChange(e, value) {
      this.$refs.ruleForm.clearValidate([value])
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }
        this.getHttpServices().getServerApiService().post('shenjie/setting', params).then(res => {
          this.$message.success('价格规则设置成功')
          this.getDetailInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
